import React, {Component} from 'react';
import {connect} from 'react-redux';
import {changePassword} from '../../actions/changePassword'

class ChangePassword extends Component {

    constructor(props) {
        super(props)
        this.state = {
            currentPassword: "",
            newPassword: "",
            confirmPassword: ""
        }
        this.onChange = this.onChange.bind(this);
        this.changePassword = this.changePassword.bind(this);
    }

    onChange(e) {
        this.setState({[e.target.name]: e.target.value});
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.response !== null && nextProps.response !== undefined){
            if (nextProps.response.success){
                this.props.history.push('/logout')
            }else {
                alert(nextProps.response.message);
            }
        }
    }

    changePassword() {
        if (this.handleValidation()) {
            let adminToken = sessionStorage.getItem("adminToken");
            this.props.dispatch(changePassword({
                password: this.state.newPassword,
                token: adminToken,
                currentPassword: this.state.currentPassword
            }));
        }
    }

    handleValidation() {
        let valid = true;
        if (this.state.currentPassword === "") {
            alert("Please enter current password");
            valid = false;
        } else if (this.state.newPassword === "") {
            alert("Please enter new password");
            valid = false;
        } else if (this.state.newPassword.length < 8) {
            alert("Please enter password with at least 8 character of length");
            valid = false;
        } else if (this.state.newPassword !== this.state.confirmPassword) {
            alert("password not metching");
            valid = false;
        }
        return valid;
    }

    render() {
        let viewHtml = '';
        if (!this.props.authenticated) {
            let adminToken = sessionStorage.getItem("adminToken");
            if (adminToken) {
                viewHtml = <div className="regPage">
                    <div className="createnewstudy">
                        <div className="studyheader"><h1>Change Password</h1></div>
                        <div className="setbackbutton">
                            <br/>
                            <br/>
                            <div className="studypage">
                                <label id="lbl1">Current Password</label>
                                <input type="password" className="textFields" placeholder="Current Password"
                                       name="currentPassword"
                                       value={this.state.currentPassword} onChange={this.onChange}/><br/>

                                <label id="lbl1">New Password</label>
                                <input type="password" className="textFields" placeholder="New Password"
                                       name="newPassword"
                                       value={this.state.newPassword} onChange={this.onChange}/><br/>

                                <label id="lbl1">Confirm Password</label>
                                <input type="password" className="textFields" placeholder="Confirm Password"
                                       name="confirmPassword"
                                       value={this.state.confirmPassword} onChange={this.onChange}/><br/>
                                <div>

                                    <div className="stdbtn">
                                        <button className="studySavebtn" onClick={this.changePassword}>Change</button>
                                    </div>
                                    <br/>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            } else {
                alert("Please login.");
                this.props.history.push("login");
            }
        }

        return (
            <div>
                {viewHtml}
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        response: state.changePassword.response,
    }
}

export default connect(mapStateToProps)(ChangePassword);



// WEBPACK FOOTER //
// ./src/pages/changePassword/index.js